import axios from "axios";
export class UtilityService {
    constructor(_baseUrl) {
        this._baseUrl = `${_baseUrl}/utility/v1`
    }
    getBrands(params) {
        return axios.get(`${this._baseUrl}/qe/motor_brands`, { params });
    }
    getCarModels(params) {
        return axios.get(`${this._baseUrl}/qe/motor_models`, { params });
    }
    getMotorYears() {
        return axios.get(`${this._baseUrl}/qe/motor_brands/model_years`);
    }
    getGovernorates() {
        return axios.get(`${this._baseUrl}/qe/governorates`);
    }
    getCities(governorate_id) {
        return axios.get(`${this._baseUrl}/qe/cities`, { params: { governorate_id } });
    }
    getIP() {
        return axios.get(`${this._baseUrl}/qe/ip/inquire-geo-data`);

    }
}
